// Helpers to get modified data from redux store
import { createSelector } from '@reduxjs/toolkit';
import {constants} from "../../common/constants/constants";

export const selectCurrentBuildingCurrencyUnsafe = state => state?.buildings.currentBuildingData?.currency ?? state?.buildings.managerData?.currency;

export const selectCurrentBuildingCurrency = createSelector(
    selectCurrentBuildingCurrencyUnsafe,
    currency => currency ?? constants.defaultCurrency
);

